// getMissingFpProRemoteConfigReason.js
'use strict';
import { createSelector } from '../resource/createCachedSelector.js';

import getOperationData from '../selector/getOperationData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import {
  FINGERPRINTJS_PRO_API_KEY,
  FINGERPRINTJS_PRO_REGION,
} from '../RemoteConfigKeys.js';

/**
 * Select missing fp pro remote config reason by
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {KEY_TYPE}  - select key.
 * @return {RETURN_TYPE} The selected missing fp pro remote config reason.
 */
const getMissingFpProRemoteConfigReason = createSelector(
  state => getOperationData(state, ['fingerprint'], 'fpIdPro'),
  state => getRemoteConfigData(state, FINGERPRINTJS_PRO_API_KEY),
  state => getRemoteConfigData(state, FINGERPRINTJS_PRO_REGION),
  (fpIdPro, fpJsAPIKey, fpJsRegion) => {
    if (fpIdPro === '') {
      const reasons = [];
      if (!fpJsAPIKey) {
        reasons.push('API Key is missing');
      }
      if (!fpJsRegion) {
        reasons.push('Region is missing');
      }

      return reasons.length ? reasons.join(', ') : 'Unknown error';
    }
    return '';
  }
);

export default getMissingFpProRemoteConfigReason;
